import { Sparkles } from "lucide-react";
import {
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  TooltipV2,
} from "../TooltipV2/TooltipV2";

interface PremiumFeatureHintProps {
  tooltip: string;
}

/** Sparkles icon with hover copy for paid-plan features. Uses a portaled tooltip so overflow on parents cannot clip it. */
export function PremiumFeatureHint({ tooltip }: PremiumFeatureHintProps) {
  return (
    <TooltipProvider delayDuration={200}>
      <TooltipV2>
        <TooltipTrigger asChild>
          <span
            data-testid="premium-feature-hint"
            className="inline-flex items-center text-amber-500"
            aria-label={tooltip}
            tabIndex={0}
          >
            <Sparkles className="h-3.5 w-3.5" aria-hidden />
          </span>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          sideOffset={6}
          className="max-w-xs z-[500] border-0 bg-gray-800 px-2 py-1.5 text-center text-xs leading-snug text-white shadow-lg"
        >
          {tooltip}
        </TooltipContent>
      </TooltipV2>
    </TooltipProvider>
  );
}
